// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var mapUnwrapFlipped = function (dictFunctor) {
    var map = Data_Functor.map(dictFunctor);
    return function () {
        return function (x) {
            return function (f) {
                return map(function ($6) {
                    return f(unwrap($6));
                })(x);
            };
        };
    };
};
var mapUnwrap = function (dictFunctor) {
    var map = Data_Functor.map(dictFunctor);
    return function () {
        return function (f) {
            return function (x) {
                return map(function ($7) {
                    return f(unwrap($7));
                })(x);
            };
        };
    };
};
var composeUnwrapRes = function () {
    return function (g) {
        return function (f) {
            return function (x) {
                return unwrap(g(f(x)));
            };
        };
    };
};
var composeUnwrapFunRes = function () {
    return function () {
        return function (g) {
            return function (f) {
                return function (x) {
                    return unwrap(g(unwrap(f(x))));
                };
            };
        };
    };
};
var composeUnwrapFun = function () {
    return function (g) {
        return function (f) {
            return function (x) {
                return g(unwrap(f(x)));
            };
        };
    };
};
var composeUnwrapArgFunRes = function () {
    return function () {
        return function () {
            return function (g) {
                return function (f) {
                    return function (x) {
                        return unwrap(g(unwrap(f(unwrap(x)))));
                    };
                };
            };
        };
    };
};
var composeUnwrapArgFun = function () {
    return function () {
        return function (g) {
            return function (f) {
                return function (x) {
                    return g(unwrap(f(unwrap(x))));
                };
            };
        };
    };
};
var composeUnwrapArg = function () {
    return function (g) {
        return function (f) {
            return function (x) {
                return g(f(unwrap(x)));
            };
        };
    };
};
var composeFlippedUnwrapRes = function () {
    return function (f) {
        return function (g) {
            return function (x) {
                return unwrap(g(f(x)));
            };
        };
    };
};
var composeFlippedUnwrapFunRes = function () {
    return function () {
        return function (f) {
            return function (g) {
                return function (x) {
                    return unwrap(g(unwrap(f(x))));
                };
            };
        };
    };
};
var composeFlippedUnwrapFun = function () {
    return function (f) {
        return function (g) {
            return function (x) {
                return g(unwrap(f(x)));
            };
        };
    };
};
var composeFlippedUnwrapArgFunRes = function () {
    return function () {
        return function () {
            return function (f) {
                return function (g) {
                    return function (x) {
                        return unwrap(g(unwrap(f(unwrap(x)))));
                    };
                };
            };
        };
    };
};
var composeFlippedUnwrapArgFun = function () {
    return function () {
        return function (f) {
            return function (g) {
                return function (x) {
                    return g(unwrap(f(unwrap(x))));
                };
            };
        };
    };
};
var composeFlippedUnwrapArg = function () {
    return function (f) {
        return function (g) {
            return function (x) {
                return g(f(unwrap(x)));
            };
        };
    };
};
var applyUnwrappedFlipped = function () {
    return function (x) {
        return function (f) {
            return f(unwrap(x));
        };
    };
};
var applyUnwrapped = function () {
    return function (f) {
        return function (x) {
            return f(unwrap(x));
        };
    };
};
var applyUnwrapUnwrappedFlipped = function () {
    return function () {
        return function (x) {
            return function (f) {
                return unwrap(f(unwrap(x)));
            };
        };
    };
};
var applyUnwrapUnwrapped = function () {
    return function () {
        return function (f) {
            return function (x) {
                return unwrap(f(unwrap(x)));
            };
        };
    };
};
var applyUnwrapFlipped = function () {
    return function (x) {
        return function (f) {
            return unwrap(f(x));
        };
    };
};
var applyUnwrap = function () {
    return function (f) {
        return function (x) {
            return unwrap(f(x));
        };
    };
};
export {
    applyUnwrapped,
    applyUnwrap,
    applyUnwrapUnwrapped,
    applyUnwrappedFlipped,
    applyUnwrapFlipped,
    applyUnwrapUnwrappedFlipped,
    composeUnwrapRes,
    composeUnwrapArg,
    composeUnwrapFun,
    composeUnwrapFunRes,
    composeUnwrapArgFun,
    composeUnwrapArgFunRes,
    composeFlippedUnwrapArg,
    composeFlippedUnwrapRes,
    composeFlippedUnwrapFun,
    composeFlippedUnwrapArgFun,
    composeFlippedUnwrapFunRes,
    composeFlippedUnwrapArgFunRes,
    mapUnwrap,
    mapUnwrapFlipped
};
